import { render, staticRenderFns } from "./DesktopEventIconSimple.vue?vue&type=template&id=b3ab8b0a"
import script from "./DesktopEventIconSimple.vue?vue&type=script&lang=js"
export * from "./DesktopEventIconSimple.vue?vue&type=script&lang=js"
import style0 from "./DesktopEventIconSimple.vue?vue&type=style&index=0&id=b3ab8b0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports